import { Fragment, type ReactNode } from 'react';
import { Alert, Button, CircularProgress } from '@mui/material';
import useUser from '@auth/useUser';
import { useGetAccountTimeZoneQuery } from '@/app/(control-panel)/admin/settings/SettingsApi';
import { detectDeviceTimeZone, setAccountTimeZone } from '@/utils/accountTimeZone';

export default function AccountTimeZoneProvider({ children }: { children: ReactNode }) {
    const { isGuest } = useUser();
    const { currentData, isError, refetch } = useGetAccountTimeZoneQuery(undefined, {
        skip: isGuest, pollingInterval: 60_000, refetchOnFocus: true, refetchOnMountOrArgChange: true
    });
    if (!isGuest && !currentData) {
        return isError
            ? <Alert severity="error" action={<Button onClick={() => refetch()}>Retry</Button>}>Unable to load the account time zone.</Alert>
            : <div className="flex justify-center p-32"><CircularProgress aria-label="Loading account settings" /></div>;
    }
    const zone = isGuest ? detectDeviceTimeZone() : currentData.timeZoneId;
    setAccountTimeZone(zone);
    // Reformat every screen when the shared clock changes, including legacy table formatters.
    return <Fragment key={zone}>{children}</Fragment>;
}
